import {
    IconButton,
    ListItem,
    ListItemButton,
    ListItemSecondaryAction,
    ListItemText,
} from '@mui/material';
import env from '@/env';
import { DeleteIcon } from '../icons';
import { Paragraph } from '../Paragraph';
import type { RecipientListInput_recipientList$data } from '../RecipientListInput/__generated__/RecipientListInput_recipientList.graphql';

type RecipientType =
    RecipientListInput_recipientList$data['recipients'][number];
export type RecipientProps = {
    recipient: RecipientType;
    onClickDelete(recipient: RecipientType): void;
    classes: Record<
        | 'respondentList_listItem'
        | 'list_item_secondary'
        | 'deleteIconButton'
        | 'deleteIcon',
        string
    >;
};

function Recipient({ onClickDelete, recipient, classes }: RecipientProps) {
    const { phoneNumber, emailAddress, respondentId } = recipient;

    const onClick = () => {
        const { respondentId } = recipient;
        window.open(`${env.ANSWER_SURVEY_URL}/survey/${respondentId}`);
    };

    const item = (
        <>
            <ListItemText
                disableTypography
                primary={<Paragraph>{emailAddress || phoneNumber}</Paragraph>}
            />
            <ListItemSecondaryAction className={classes.list_item_secondary}>
                <IconButton
                    onClick={() => onClickDelete(recipient)}
                    classes={{ root: classes.deleteIconButton }}
                    size="large"
                >
                    <DeleteIcon className={classes.deleteIcon} />
                </IconButton>
            </ListItemSecondaryAction>
        </>
    );
    return (
        <ListItem className={classes.respondentList_listItem}>
            {respondentId ? (
                <ListItemButton onClick={onClick}>{item}</ListItemButton>
            ) : (
                item
            )}
        </ListItem>
    );
}

export default Recipient;
